export default __webpack_public_path__ + "static/media/movies.12c2255d.svg";